<nav class="navbar-expand navbar-light top-menu" [hidden]="!showMenu">
    <div class="fluid-container">
        <div class="d-flex">
            <div class="navbar-nav pe-0 mx-auto">
                <a
                    *ngIf="communityIsValid | async"
                    class="navbar-brand d-none d-lg-block"
                    [routerLink]="'/' + communityCode + '/home'"
                    (click)="navbarCollapsed = true"
                >
                    <img
                        id="menuLogo"
                        class="menulogo"
                        [attr.src]="'menu-logo' | cmsImageSrc | async"
                        [attr.alt]="'menu-logo' | cmsImageAlt | async"
                    />
                </a>
            </div>
        </div>
    </div>
</nav>

<header
    class="navbar navbar-expand-lg navbar-light bg-white shadow-sm custom-sticky-top"
    [hidden]="!showMenu"
>
    <div class="container">
        <a
            *ngIf="communityIsValid | async"
            class="navbar-brand d-block d-lg-none mx-auto"
            [routerLink]="'/' + communityCode + '/home'"
            (click)="navbarCollapsed = true"
        >
            <img
                id="menuLogoMobile"
                class="menulogo p-1"
                [attr.src]="'menu-logo-mobile' | cmsImageSrc | async"
                [attr.alt]="'menu-logo-mobile' | cmsImageAlt | async"
            />
        </a>
        <button
            class="navbar-toggler"
            [hidden]="!showMenuLinks"
            type="button"
            (click)="navbarCollapsed = !navbarCollapsed"
            [attr.aria-expanded]="!navbarCollapsed"
            aria-controls="navbarContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon"></span>
            <p class="my-2 small">メニュー</p>
        </button>

        <div
            class="navbar-collapse"
            [ngbCollapse]="navbarCollapsed"
            id="navbarContent"
        >
            <nav
                [hidden]="!showMenuLinks"
                *ngIf="communityIsValid | async"
                class="navbar-nav mx-auto"
            >
                <ng-container *ngFor="let item of items">
                    <a
                        *ngIf="!item.children"
                        class="nav-item nav-link ms-4 text-uppercase"
                        [routerLink]="'/' + communityCode + item.link"
                        id="{{ item.id }}"
                        [routerLinkActive]="['active']"
                        (click)="navbarCollapsed = true"
                    >
                        {{ item.cmsKey | cmsText | async }}
                    </a>
                    <div
                        *ngIf="item.children"
                        ngbDropdown
                        placement="bottom-right"
                        class="d-inline-block"
                    >
                        <button
                            class="dropdown-item nav-link ms-4"
                            id="moreInfoDropdown"
                            ngbDropdownToggle
                        >
                            {{ item.cmsKey | cmsText | async }}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="moreInfoDropdown">
                            <a
                                *ngFor="let childItem of item.children"
                                class="dropdown-item"
                                [routerLink]="
                                    '/' + communityCode + childItem.link
                                "
                                (click)="moreInfoDropdownClick()"
                                >{{ childItem.cmsKey | cmsText | async }}</a
                            >
                        </div>
                    </div>
                </ng-container>
                <ul class="navbar-nav ms-auto d-none d-lg-block my-auto">
                    <li class="nav-item">
                        <span
                            class="badge bg-info ms-4"
                            *ngIf="authService.user$ | async; let admin"
                            >{{ admin.name }}</span
                        >
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</header>
